module.exports = __webpack_public_path__ + "img/icon-three.cd64d249.svg";